import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { canAccessRoute } from '@/utils/roleAccess';
import { homeForRole } from '@/utils/homeForRole';
import { loginUrlWithReturn } from '@/utils/loginReturnPath';

/** Gate a screen by role list and/or any of the given permission codes. */
export default function ProtectedRoute({ children, allowedRoles, anyPermission }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-[#F9FAFB]">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin text-[#F15A22] mx-auto mb-2" />
          <p className="text-gray-500 text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user || user === false) {
    return <Navigate to={loginUrlWithReturn(location.pathname, location.search)} replace />;
  }

  if (!canAccessRoute(user, { allowedRoles, anyPermission })) {
    return <Navigate to={homeForRole(user.role, user)} replace />;
  }

  return children;
}
